/*global $*/
/*eslint no-undef: "error"*/
export default class Gallery {
    classBlock = 'gallery--block'
    classButton = 'gallery--button'

    classBlockOpen = 'gallery-open'

    constructor () {
        let self = this

        $(`.${self.classButton}`).click(function () {
            $(this).closest(`.${self.classBlock}`).toggleClass(self.classBlockOpen)
        })
    }
}
